<template>

    <div class="equipment-view-attestation">
        <spinner-until :condition="!attesting">
            <b-card no-body>
                <b-card-header class="pod-heading">
                    <h5>Equipment Status</h5>
                    <div class="heading__buttons">
                        <attestation-badge :equipment="equipment"/>
                    </div>
                </b-card-header>
                <b-card-body>
                    <template v-if="equipment.attestationStatus === 'INCOMPLETE'">
                        <p>Equipment details are incomplete - these must be completed before attestation.</p>
                        <template v-if="canEdit">
                            <hr/>
                            <b-btn variant="success" class="float-right"
                                   :to="`/equipment/edit/${equipment.id}`">
                                Edit Equipment
                                <b-icon-pencil-square/>
                            </b-btn>
                        </template>

                    </template>
                    <template v-if="equipment.attestationStatus === 'UPDATED'">
                        Equipment details are complete, but must be attested before determining compliance.
                        <hr/>
                        <b-btn variant="success" class="float-right"
                               v-if="canAttest"
                               @click="attestEquipment()">
                            Attest Equipment Details
                            <b-icon-bag-check/>
                        </b-btn>
                        <i v-if="!canAttest">You do not have permission to attest. Only a company admin can
                            attest.</i>
                    </template>
                    <template v-if="equipment.attestationStatus === 'ATTESTED'">
                        <template v-if="equipment.engine_family_name.includes('[No match found]')">
                            <p>Equipment details are complete and have been attested, but no matching Engine Family was found.</p>
                            <p>Please select a matching Engine Family or reach out to the App Admin to continue:</p>
                            <hr>
                            <b-btn @click="showMessageModal()" variant="warning">
                              Request Assistance
                              <b-icon-box-arrow-right/>
                            </b-btn>
                            <template v-if="canEdit">
                              <b-btn variant="success" class="float-right"
                                     :to="`/equipment/edit/${equipment.id}`">
                                Edit Equipment
                                <b-icon-pencil-square/>
                              </b-btn>
                            </template>
                        </template>
                        <template v-else>
                            <p>Equipment details are complete and have been attested.</p>
                            <p>If equipment details are edited, re-attestation will be required.</p>
                        </template>
                    </template>
                </b-card-body>
            </b-card>
        </spinner-until>

        <message-create-modal :modalId="modalId" :recipient="appAdmin"/>

        <b-modal id="attestation-failed" title="Attestation Failed - Document Required" ok-only>
            IMPORTANT! ADDITIONAL ACTION REQUIRED. <br>
            Your Tier 4 (or DPF-retrofitted) equipment requires additional validation.
            To complete this equipment’s registration, you must attach a photo of this equipment's engine label (clearly
            showing the engine family name), or of the DPF retrofit, in the Uploaded Documents section below.
            The photo will be reviewed by the CAC program for validation prior to mailing your compliance decal.
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import Authorization from '@/providers/Authorization'

export default Vue.extend({
    name: 'EquipmentViewAttestation',
    props: {
        equipment: Object,
    },
    data () {
        return {
            attesting: false,
            canAttest: false,
            appAdmin: null,
        }
    },
    computed: {
        canEdit () {
            return this.$user.isSuperAdmin() || this.$user.isAdmin() ||
                this.$user.isEquipmentOwner() || this.$user.isOwnersRepresentative()
        },
        hash () {
          return Math.random().toString(36).substr(2, 5)
        },
        modalId () {
          return 'message_modal' + this.hash
        },
    },
    methods: {
        // TODO: check permissions
        async attestEquipment () {
            const val = await this.$bvModal.msgBoxConfirm(
                'I hereby attest to the correctness of all entered details for this equipment; I will maintain my equipment, including any emissions control devices, in proper working order; and I will provide timely updates of any changes to my equipment that could affect its compliance with Clean Air Construction requirements.', {
                    title: 'Attestation',
                    size: 'lg',
                    buttonSize: 'default',
                    okVariant: 'success',
                    okTitle: 'Attest',
                    cancelTitle: 'Cancel',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
            if (val) {
                this.attesting = true
                try {
                    let success = await this.$api.attestEquipment(this, this.equipment.id)
                    this.attesting = false

                    console.log(success.body)
                    if (success.body) {
                        console.log('goody')
                        this.$emit('attested')
                    } else {
                        console.log('fail')
                        this.$bvModal.show('attestation-failed')
                    }
                } catch (e) {
                    this.$toasted.error('Error: Could not attest equipment details')
                    this.attesting = false
                }
            }
        },
        showMessageModal () {
          this.$bvModal.show(this.modalId)
        },
        async getAppAdmin () {
          const response = await this.$api.getAppAdmin()
          this.appAdmin = response.body
        },
    },
    created () {
        Authorization.can({ model: 'equipment', action: 'attest', arg: this.equipment.id }).then((can) => {
            this.canAttest = can
        })
        this.getAppAdmin()
    }
})
</script>
